import {
  styled,
  TableCell,
  tableCellClasses,
  TableRow,
  TextField,
} from "@mui/material";
import { FC, useState, useEffect } from "react";
import { ActionType } from "../../../types/AlertType";
import { TarifInterface } from "../../content/parametrage/Tarification/InterfaceTarification";
import { Article, OperationInterfaceWith } from "./AddtarifForms";
interface IRowAddtarifAtribute {
  rowTarifSiExiste?: TarifInterface[];
  rowArticle: Article;
  handleChangeTarif: (tarifRow: TarifInterface, action: ActionType) => void;
  idOperationSansTarif?: Number[];
  operationSelected: OperationInterfaceWith;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    textAlign: "center",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "center",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const RowAddTarif: FC<IRowAddtarifAtribute> = ({
  rowArticle,
  handleChangeTarif,
  idOperationSansTarif,
  rowTarifSiExiste,
  operationSelected,
}) => {
  const [tarifRowToSave, setTarifRowToSave] = useState<TarifInterface>({
    article_id:
      rowTarifSiExiste?.find(
        (tar) => tar?.article_id == rowArticle?.id
      )?.id !== undefined
        ? (rowTarifSiExiste?.find(
            (tar) => tar?.article_id == rowArticle?.id
          )?.article_id as number)
        : (rowArticle?.id as number),
    tarifacte: "",
    tarifheure: "",
  });

  useEffect(() => {
    // Creation Du TarifRef Pour le Sauvegarde
    const tarifRowToSavetemp: TarifInterface = {
      article_id:
        rowTarifSiExiste?.find(
          (tar) => tar?.article_id == rowArticle?.id
        )?.id !== undefined
          ? (rowTarifSiExiste?.find(
              (tar) => tar?.article_id == rowArticle?.id
            )?.article_id as number)
          : (rowArticle?.id as number),
      tarifacte: "",
      tarifheure: "",
    };
    // Creation Du Tarif Dans Classe Mere
    handleChangeTarif(tarifRowToSavetemp, "CREATE");
    setTarifRowToSave(tarifRowToSave);
  }, [operationSelected]);

  useEffect(() => {
    let updatedTarif = tarifRowToSave;
    updatedTarif.tarifacte =
      rowTarifSiExiste === undefined || rowTarifSiExiste.length == 0
        ? ""
        : (rowTarifSiExiste?.find(
            (tar) => tar?.article_id == rowArticle?.id
          )?.tarifacte as string);
    updatedTarif.tarifheure =
      rowTarifSiExiste === undefined || rowTarifSiExiste.length == 0
        ? ""
        : (rowTarifSiExiste?.find(
            (tar) => tar?.article_id == rowArticle?.id
          )?.tarifheure as string);
    setTarifRowToSave(updatedTarif);
    handleChangeTarif(updatedTarif, "UPDATE");
  }, [rowTarifSiExiste]);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const updatedtarif = {
      ...tarifRowToSave,
      [name]: value,
    };
    setTarifRowToSave(updatedtarif);
    handleChangeTarif(updatedtarif, "UPDATE");
    
  };
  console.log(rowTarifSiExiste);
  console.log(tarifRowToSave);
  return (
    <StyledTableRow>
      <StyledTableCell>{rowArticle?.code_article?.libelleCodeArticle}</StyledTableCell>
      <StyledTableCell>{rowArticle?.libelle}</StyledTableCell>
      <StyledTableCell>
        <TextField
        type="number"
          name="tarifheure"
          label="Tarif heure"
          color="warning"
          variant="filled"
          size="small"
          fullWidth
          autoComplete="off"
          error={idOperationSansTarif?.includes(rowArticle?.id)}
          disabled={
            rowTarifSiExiste === undefined || rowTarifSiExiste.length == 0
              ? false
              : rowTarifSiExiste?.find(
                  (tar) => tar?.article_id == rowArticle?.id
                )?.date_debut !== undefined
              ? true
              : false
          }
          value={tarifRowToSave?.tarifheure}
          onChange={handleChange}
          /*InputLabelProps={{
                shrink: CheckAttr(coutToSave?.coutactivite),
              }}*/
        />
      </StyledTableCell>
      
      <StyledTableCell>
        <TextField
        type="number"
          name="tarifacte"
          label="Tarif Acte"
          color="warning"
          variant="filled"
          size="small"
          fullWidth
          autoComplete="off"
          disabled={
            rowTarifSiExiste === undefined || rowTarifSiExiste.length == 0
              ? false
              : rowTarifSiExiste?.find(
                  (tar) => tar?.article_id == rowArticle?.id
                )?.date_debut !== undefined
              ? true
              : false
          }
          error={idOperationSansTarif?.includes(rowArticle?.id)}
          value={tarifRowToSave?.tarifacte}
          onChange={handleChange}
          /*InputLabelProps={{
                shrink: CheckAttr(coutToSave?.coutformation),
              }}*/
        />
      </StyledTableCell>
      
      <StyledTableCell>{rowArticle?.devise?.code_iso}</StyledTableCell>
      {rowTarifSiExiste?.find(
        (tar) => tar?.article_id == rowArticle?.id
      )?.date_fin !== undefined && (
        <StyledTableCell>
          <TextField
            disabled={true}
            name="date_debut"
            //label="Date debut"
            type="date"
            color="warning"
            sx={{ width: 140 }}
            fullWidth
            /*disabled={disable}*/
            value={
              rowTarifSiExiste === undefined || rowTarifSiExiste.length == 0
                ? ""
                : rowTarifSiExiste?.find(
                    (tar) => tar?.article_id == rowArticle?.id
                  )?.date_debut
            }
            InputLabelProps={{
              shrink: true,
            }}
          />
        </StyledTableCell>
      )}
      {rowTarifSiExiste?.find(
        (tar) => tar?.article_id == rowArticle?.id
      )?.date_fin !== undefined && (
        <StyledTableCell>
          <TextField
            disabled={true}
            name="date_fin"
            // label="Date Fin"
            type="date"
            color="warning"
            fullWidth
            sx={{ width: 140 }}
            /*disabled={disable}*/
            value={
              rowTarifSiExiste === undefined || rowTarifSiExiste.length == 0
                ? ""
                : rowTarifSiExiste?.find(
                    (tar) => tar?.article_id == rowArticle?.id
                  )?.date_fin
            }
            InputLabelProps={{
              shrink: true,
            }}
          />
        </StyledTableCell>
        
      )}
    </StyledTableRow>
  );
};

export default RowAddTarif;
